import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { css } from "styled-components";
export var filterRowDisplayStyles = css([
    "display:flex;align-items:end;",
    "{align-items:center;}",
    "{align-items:flex-start;}"
], responsiveMediaQueries.tabletAndBelow, responsiveMediaQueries.mobile);
